import React from "react";
import "./HomeHero.css";
import videoSource from "../images/inicioHome.mp4";
import heroPoster from "../images/inicioHome-poster.webp";
import { useTranslation } from "../i18n";

function HomeHero() {
    const { t } = useTranslation();

    return (
        <section className="inicio-hero" style={{ "--hero-poster": `url(${heroPoster})` }}>
            <video
                className="video-background"
                autoPlay
                loop
                muted
                playsInline
                preload="metadata"
                poster={heroPoster}
            >
                <source src={videoSource} type="video/mp4" />
                {t("common.browserVideo")}
            </video>

            {/* Capa de opacidad */}
            <div className="overlay"></div>

            {/* Contenido principal */}
            <div className="inicio-hero-container">
                <div className="inicio-hero-content">
                    <h1>{t("home.heroTitle")} <span className="theqahub-font" translate="no">{"</"}TheQAHub{">"}</span></h1>
                    <h2>{t("home.heroSubtitle")}</h2>
                    <p>{t("home.heroText")}</p>
                </div>
                <div className="empty-column"></div>
                <div className="empty-column"></div>
            </div>
        </section>
    );
}

export default HomeHero;
